import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './components/home/home.component';
import { CentrosComponent } from './components/centros/centros.component';
import { GruposComponent } from './components/grupos/grupos.component';
import { PersonasComponent } from './components/personas/personas.component';
import { ServiciosComponent } from './components/servicios/servicios.component';
import { EmpleoComponent } from './components/empleo/empleo.component';
import { SeguimientoComponent } from './components/beneficiarios/seguimiento.component';
import { LoginComponent } from './components/login/login.component';
import { ProgramasComponent } from './components/programas/programas.component';
import { InstitucionesComponent } from './components/instituciones/instituciones.component';
import { AuthGuard } from './guards/auth.guard';
import { FormulariosComponent } from './components/formularios/formularios.component';

const routes: Routes = [
  { path: '', redirectTo: 'home', pathMatch: 'full'},
  { path: 'home', component: HomeComponent, canActivate: [AuthGuard]},
  { path: 'centros', component: CentrosComponent, canActivate: [AuthGuard] },
  { path: 'grupos', component: GruposComponent, canActivate: [AuthGuard] },
  { path: 'colaboradores', component: PersonasComponent, canActivate: [AuthGuard] },
  { path: 'servicios', component: ServiciosComponent, canActivate: [AuthGuard] },
  { path: 'empleos', component: EmpleoComponent, canActivate: [AuthGuard] },
  { path: 'seguimiento', component: SeguimientoComponent, canActivate: [AuthGuard] },
  { path: 'programas', component: ProgramasComponent, canActivate: [AuthGuard] },
  { path: 'instituciones', component: InstitucionesComponent, canActivate: [AuthGuard] },
  { path: 'formularios', component: FormulariosComponent, canActivate: [AuthGuard] },
  { path: 'login', component: LoginComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
